import { FullHouseProperties } from "@lib/js-slingo-pawnshop-core/dist";
/**
 * BigWinLandscapeProperties.ts
 */
export class FullHouseLandscapeProperties extends FullHouseProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.position.set(973, 375);
    }
}
